import React from "react";
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";

interface ButtonSubmitProps {
  isSubmitting: boolean;
  className?: string;
  variant?: any;
  size?: any;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
}

export const ButtonSubmit: React.FC<ButtonSubmitProps> = ({
  isSubmitting,
  className = "",
  variant = "default",
  size = "default",
  type = "submit",
  disabled = false,
  onClick,
  children,
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      type={type}
      className={className}
      disabled={disabled || isSubmitting}
      onClick={onClick}
    >
      {isSubmitting && <RotateCw className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Button>
  );
};

ButtonSubmit.displayName = "ButtonSubmit";
